module.exports = __webpack_public_path__ + "static/media/CN.ce4c8db3.svg";